import quickFetch from 'quick-fetch';

const gateName = 'hs-resources:FLPViewEnforcement';

let cachedResult: string | undefined;

export const readFLPGate = () => cachedResult;

export const __TEST_ONLY_resetFLPGate = () => {
  cachedResult = undefined;
};

export const __TEST_ONLY_setFLPGate = (value: 'true' | 'false') => {
  cachedResult = value;
};

export const checkFLPGate = () =>
  new Promise<string>((resolve) => {
    // Bail if the auth request hasn't been made (happens before early bundle in quartz apps)
    if (!quickFetch.getLoginVerifyRequest()) {
      cachedResult = 'false';
      resolve('false');
      return;
    } else {
      let timedOut = false;

      // Fail closed if auth takes too long
      const safetyTimeout = setTimeout(() => {
        cachedResult = 'false';
        timedOut = true;
        resolve('false');
      }, 1000);

      // Wait on the auth callback
      quickFetch.afterAuth((auth) => {
        if (!timedOut) {
          clearTimeout(safetyTimeout);
          cachedResult = auth.portal.enabled_v3_gates?.includes(gateName)
            ? 'true'
            : 'false';
          resolve(cachedResult);
        }
      });
    }
  });
